import * as React from 'react';
import cx from 'classnames';
import Link from '@src/components/link';
import wrapStore from '@src/utils/wrap-store';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
import ToTopBtn from '../to-top-btn';
import LanguageSelect from '../common-language-select';
import CookieTips from './components/cookie-tips';
import FooterStore from './store';
import styles from './index.less';
const lang = getLanguageByPath();

const Footer = ({ store }) => {
  store.use();
  // 认证标识
  const renderTrusTe = () => {
    return (
      <React.Fragment>
        {store.footerLeftLogo.map(
          (item, index) =>
            item.img &&
            (item.url ? (
              <a key={index} href={item.url} target="_blank">
                <img src={item.img} />
              </a>
            ) : (
              <img key={index} src={item.img} />
            ))
        )}
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>
      <CookieTips store={store.cookieTipsStore} />
      <div
        className={cx(styles.footer, {
          [styles.rootAct]: store.isActive,
          [styles.rootAct1]: store.isActive && store.isWaterfall
        })}
      >
        <div className={styles.footer_container}>
          <div className={styles.footer_top}>
            <div className={styles.footer_information_container}>
              {/* 官方工具 */}
              <ul className={styles.information_title}>
                {store.footerLinks.map((section, index) => (
                  <li key={index}>
                    <span className={styles.information_title_content}>{section.title}</span>
                    <div className={styles.information_list}>
                      {section.items.map((item, itemIndex) => (
                        <div key={itemIndex} className={styles.information_list_content}>
                          {item.href ? (
                            <Link href={item.href} target="_blank">
                              {item.text}
                            </Link>
                          ) : (
                            item.text
                          )}
                        </div>
                      ))}
                    </div>
                  </li>
                ))}
              </ul>
            </div>

            {/* 语言选择 */}
            <LanguageSelect buttonDisplay={'footer'} store={store.selectStore} />

            {/* 回到顶部 */}
            <div className={styles.topBtn}>
              <ToTopBtn store={store.toTopBtnStore} />
            </div>
          </div>
          <div className={styles.footer_bottom} style={{ display: lang === 'th' && 'flex' }}>
            <div className={styles.l_bottom}>
              <div className={styles.footer_agreem_list}>
                {store.agreementLinks.filter(item => item.text).map((item, index, filteredArray) => (
                  <React.Fragment key={index}>
                    {item.href ? (
                      <Link href={item.href} target="_blank" className={item.isFontWeight && styles.fontWeight}>
                        {item.text}
                      </Link>
                    ) : (
                      <Link onClick={() => item.cookieSetting && store.handleCookieSetting()}>{item.text}</Link>
                    )}
                    {index < filteredArray.length - 1 && <span className={styles.agreem_line}>|</span>}
                  </React.Fragment>
                ))}
              </div>
              {/* 底部文案信息 */}
              {store.footerTextInfo.filter(item => item.text).map((item, index) => (
                <div key={index} className={styles.footer_copyright}>
                  {item.href ? (
                    <Link href={item.href} target="_blank">
                      {item.text}
                    </Link>
                  ) : (
                    item.text
                  )}
                </div>
              ))}
            </div>
            <div className={styles.r_bottom}>
              <div className={styles.truste}>{renderTrusTe()}</div>
              <div className={styles.r_logo}>
                {store.footerRightLogo.map((item, index) => (
                  <React.Fragment key={index}>
                    <Link href={item.url} target="_blank">
                      <img src={item.img} alt={item.name} />
                    </Link>
                    {index < store.footerRightLogo.length - 1 && <div className={styles.logo_line} />}
                  </React.Fragment>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default wrapStore(Footer, FooterStore);
